<template>
<div id="sheets-export">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>
          <span v-if="!isNational">
            {{ region }}
          </span>
          <span v-else>
            Programme National
          </span>
          {{ year }}
        </small>
        <br>
        Exports CSV
      </h1>
      <hr>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="panel panel-info">
        <div class="panel-heading">
          <div v-show="waiting">
            Récupération des données...
          </div>
          <div v-show="datasetList.length > 0">
            <dropdown ref="dropdown">
              <btn type="warning" class="dropdown-toggle">
                Jeu de donnée <span class="caret"></span>
              </btn>
              <template slot="dropdown">
                <li>
                  <a role="button" @click="dataset = null">
                    (Aucun)
                  </a>
                </li>
                <li v-for="d in datasetList"
                    :key="`dataset-${d}`">
                  <a role="button" @click="dataset = d">
                    {{ d }}
                  </a>
                </li>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="!waiting">
    <h2 v-if="dataset == null">Toutes les fiches validées</h2>
    <h2 v-else>Fiches «{{ dataset }}»</h2>
    <alert type="info">
      <p><strong>Attention !</strong></p>
      <p v-if="dataset == null">
        Seules les fiches <strong>validées</strong> sont exportées.
      </p>
      <p>
        Les dénominateurs sont téléchargées au <strong>format CSV</strong>.
      </p>
    </alert>
    <span class="export-button" v-for="e in exportList" :key="`export-${e.mod}`">
      <btn size="lg"
           :type="e.mod"
           :disabled="active"
           @click="exportSheets(e.mod)">
        {{e.label}}
      </btn>
    </span>
    <div v-if="datasetType === 1 || datasetType === 3">
      <export-infections :year="year" :dataset="dataset"/>
      <export-datasets :year="year" :dataset="dataset"/>
    </div>
    <div v-if="datasetType <= 1 && parseInt(year) >= 2021">
      <export-explaur :year="year"
       :surveillances="allSurveillances"/>
    </div>
    <div v-if="datasetType === 1">
      <export-ecdc :year="year"
                   :dataset="dataset"
                   :surveillances="allSurveillances" />
    </div>
    <div v-if="dataset == null">
      <export-single-sheets :year="year"
                            :surveillances="surveillances"/>
    </div>
  </div>
  <save-blob :target="target"></save-blob>
</div>
</template>
<script>
import exportInfections from '@/components/exportinfections'
import exportDatasets from '@/components/exportdatasets'
import exportExplaur from '@/components/exportexplaur'
import exportEcdc from '@/components/exportecdc'
import exportSingleSheets from '@/components/exportsinglesheets'

import dataset from '@/sui/tools/dataset'
import saveBlob from '@/sui/components/saveblob'

import modules from '@/sui/data/modules'
import csv from '@/sui/data/sheets/csv'

import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'sheets-export',

  props: {
    year: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      target: null,
      dataset: null,
      active: false
    }
  },

  computed: {

    ...mapState({
      datasetsLoaded: state => state.dataset.names.loaded,
      datasets: state => state.dataset.names.values,
      allSurveillances: state => state.surveillances.all
    }),

    datasetList: function () {
      return this.datasets[this.year]
    },

    isNational: function () {
      return this.$route.path.match(/^\/mission/)
    },

    exportList: function () {
      if (this.year == null || this.year === '') {
        return null
      }
      const result = []
      const list = modules[this.year]
      for (let m in list) {
        const mod = list[m]
        if (mod.sheets && mod.sheets.flatten != null) {
          result.push(
            {
              mod: m,
              label: mod.label
            }
          )
        }
      }

      if (this.datasetType === 0) {
        return result
      }

      return dataset.filterModulesFromDatasetType(
        result, this.datasetType, 'mod'
      )
    },

    datasetType: function () {
      if (this.dataset == null || this.dataset === '') {
        return 0
      }

      return dataset.getDatasetType(this.dataset)
    },

    surveillances: function () {
      if (this.year == null || this.year === '') {
        return null
      }

      const result = this.allSurveillances[this.year].slice().sort(
        (f, s) => f.id.localeCompare(s.id)
      )
      return result
    },

    waiting: function () {
      return this.surveillances.length === 0 || !this.datasetsLoaded
    }
  },

  methods: {
    fill: function () {
      const y = this.year
      if (y != null && this.allSurveillances[y].length === 0) {
        this.$store.dispatch('surveillances/all', y)
      }

      if (this.datasetList.length === 0) {
        this.$store.dispatch('dataset/allSpiadiNames', false)
      }
    },

    setError: function (err) {
      this.active = false
      this.$notify({
        type: 'danger',
        title: 'Erreur !',
        content: `Impossible d'exporter les données: ${err}.`
      })
    },

    exportFull: function (module, m) {
      const reducer = (result, s) => {
        if (s.modules[m] != null) {
          result.push(s.id)
        }
        return result
      }
      const list = this.surveillances.reduce(reducer, [])
      if (list.length === 0) {
        this.$notify({
          type: 'warning',
          title: 'Aucune fiche !',
          content: `Aucune fiche n'a été validée pour cette modalité.`
        })
        return
      }

      this.getSheets(
        'bosheet/full',
        module,
        { t: m, sv: list, st: 'valid', y: parseInt(this.year) },
        `sheets-${m}`,
        m
      )
    },

    exportSheets: function (m) {
      if (m === 'reaBactADI') {
        this.$notify(
          {
            type: 'warning',
            title: 'Export non disponible !',
            content: `L'export des fiches Réa Bact-ADI est temporairement désactivé.`
          }
        )
        return
      }

      const year = this.year === '2019' ? '2020' : this.year
      const module = modules[year][m]

      if (this.dataset == null) {
        this.exportFull(module, m)
        return
      }

      this.getSheets(
        'dataset/sheets',
        module,
        {
          name: this.dataset,
          mod: m,
          step: m === 'observa4' ||
                m === 'spy4' ||
                m === 'badiCause' ? 1 : 2
        },
        `sheets-${this.dataset}-${m}`,
        m
      )
    },

    getSheets: function (event, module, request, name, type) {
      const vm = this

      const date = moment().format('DD-MM-YYYY-HH-mm-ss')
      this.active = true
      this.$store.dispatch(event, request).then(
        (response) => {
          let { err, v } = response.data
          if (err != null) {
            vm.setError(err)
            return response
          }

          if (v.length === 0) {
            vm.setError('Aucune fiche dans la modalité')
            return response
          }

          const data = vm.dataset == null ? `Fiches validées SPIADI${vm.year}` : vm.dataset
          const filename = `${data} - ${module.label} - ${date}.csv`

          csv(
            filename,
            vm,
            vm.surveillances,
            type,
            vm.year,
            v,
            (r) => {
              vm.active = false
              vm.target = r
            },
            vm.setError
          )
        }
      ).catch(e => { vm.setError(e) })
    }
  },

  watch: {
    year: function () {
      this.dataset = null
      this.fill()
    }
  },

  mounted: function () {
    this.fill()
  },

  components: {
    'export-infections': exportInfections,
    'export-datasets': exportDatasets,
    'save-blob': saveBlob,
    'export-explaur': exportExplaur,
    'export-ecdc': exportEcdc,
    'export-single-sheets': exportSingleSheets
  }
}
</script>
<style scoped lang="less">
#sheets-export {
  .export-button .btn {
    margin: 0.3rem;
  }
}
</style>
